var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIconz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13477 16.9131H6.13477C5.60433 16.9131 5.09562 16.7024 4.72055 16.3273C4.34548 15.9522 4.13477 15.4435 4.13477 14.9131V6.91309C4.13477 6.38265 4.34548 5.87395 4.72055 5.49887C5.09562 5.1238 5.60433 4.91309 6.13477 4.91309H14.1348C14.6652 4.91309 15.1739 5.1238 15.549 5.49887C15.9241 5.87395 16.1348 6.38265 16.1348 6.91309V8.91309M10.1348 20.9131H18.1348C18.6652 20.9131 19.1739 20.7024 19.549 20.3273C19.9241 19.9522 20.1348 19.4435 20.1348 18.9131V10.9131C20.1348 10.3827 19.9241 9.87395 19.549 9.49887C19.1739 9.1238 18.6652 8.91309 18.1348 8.91309H10.1348C9.60433 8.91309 9.09563 9.1238 8.72055 9.49887C8.34548 9.87395 8.13477 10.3827 8.13477 10.9131V18.9131C8.13477 19.4435 8.34548 19.9522 8.72055 20.3273C9.09563 20.7024 9.60433 20.9131 10.1348 20.9131Z",
    stroke: "#97144D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconz);
export default __webpack_public_path__ + "static/media/copyIconz.5bb1939f9db302a54f75b6cca08a79da.svg";
export { ForwardRef as ReactComponent };